import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const SUPABASE_BUCKET = process.env.REACT_APP_SUPABASE_BUCKET || "Immagini Sito";

function getClient() {
  const client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: "rubiana-auth",
      flowType: "pkce",
    },
  });
  return client;
}

export const supabase = getClient();

export function formatSupabaseError(err) {
  if (!err) return "Errore sconosciuto";
  if (typeof err === "string") return err;
  
  if (err.message) {
    const m = err.message;
    if (/Invalid login credentials/i.test(m)) return "Credenziali non valide";
    if (/already registered/i.test(m)) return "Email già registrata";
    if (/User already registered/i.test(m)) return "Email già registrata";
    if (/Password should be at least/i.test(m)) return "La password deve avere almeno 6 caratteri";
    if (/Email not confirmed/i.test(m)) return "Conferma la tua email prima di accedere";
    return m;
  }
  
  return JSON.stringify(err);
}